import { render, staticRenderFns } from "./authorityControl.vue?vue&type=template&id=5f3d3fba&scoped=true"
import script from "./authorityControl.vue?vue&type=script&lang=js"
export * from "./authorityControl.vue?vue&type=script&lang=js"
import style0 from "./authorityControl.vue?vue&type=style&index=0&id=5f3d3fba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3d3fba",
  null
  
)

export default component.exports